// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__e3lSB","label":"Completed_label__1JW7W"};